export default {"src":"/_next/static/media/lang2.f65dd6da.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};